export const NAV_ITEMS = [
  { label: "Home", id: "home", path: "/" },
  { label: "Services", id: "services", path: "/services" },
  { label: "Fleet", id: "fleet", path: "/fleet/sedan" },
  { label: "Book", id: "booking", path: "/reserve" },
  { label: "Airport", id: "airport", path: "/airports" },
  { label: "Corporate", id: "corporate", path: "/corporate" },
  { label: "About", id: "about", path: "/about" },
  { label: "Contact", id: "contact", path: "/contact" },
];

// Complete public page directory for the wrapping footer. Keeping this
// separate prevents additional long labels from squeezing the approved
// desktop header or mobile-menu layout.
export const FOOTER_NAV_ITEMS = [
  ...NAV_ITEMS,
  {
    label: "Long-Distance",
    id: "long-distance",
    path: "/long-distance",
  },
  {
    label: "Service Areas",
    id: "service-areas",
    path: "/service-areas",
  },
];

export const VEHICLES = [
  {
    id: "sedan",
    name: "Sedan",
    img: "/vehicles/sedan.png",
    passengers: 3,
    luggage: 2,
    price: 120,
  },
  {
    id: "suv",
    name: "SUV",
    img: "/vehicles/suv.png",
    passengers: 6,
    luggage: 4,
    price: 160,
  },
  {
    id: "van",
    name: "Transit Van",
    img: "/vehicles/van.png",
    passengers: 10,
    luggage: 8,
    price: 180,
  },
  {
    id: "sprinter",
    name: "Sprinter",
    img: "/vehicles/sprinter.png",
    passengers: 13,
    luggage: 10,
    price: 220,
  },
];

export const FEATURES = [
  { icon: "Clock", title: "Always On Time", desc: "Your time is our priority. We guarantee punctuality." },
  { icon: "UserRound", title: "Professional Chauffeurs", desc: "Highly trained, discreet and committed to excellence." },
  { icon: "ShieldCheck", title: "Safety First", desc: "Your safety is our top priority always." },
  { icon: "Headphones", title: "24/7 Service", desc: "Reservations and support available around the clock." },
  { icon: "BadgeDollarSign", title: "$5M Commercially Insured", desc: "$5 Million commercially insured for your peace of mind." },
  { icon: "Plane", title: "Flight Monitoring", desc: "We track your flight in real-time for a seamless experience." },
  { icon: "Star", title: "Luxury Fleet", desc: "Late model vehicles maintained to the highest standards." },
  { icon: "EyeOff", title: "Discreet Service", desc: "Confidential, low-profile chauffeur presence for executives and VIP clients." },
];

export const SERVICE_AREAS = [
  "Los Angeles", "Newport Beach",
  "Beverly Hills", "Huntington Beach",
  "Santa Monica", "Laguna Beach",
  "Long Beach", "Costa Mesa",
  "Anaheim", "And More",
  "Irvine",
];

export const LONG_DISTANCE = [
  "Las Vegas", "Palm Springs",
  "San Diego", "California Wine Country",
  "San Francisco", "And More Destinations",
];

export const AIRPORTS = [
  { code: "LAX", name: "Los Angeles Intl",       full: "Los Angeles International Airport",  slug: "lax",     private: false },
  { code: "SNA", name: "John Wayne",             full: "John Wayne Airport (Orange County)", slug: "sna",     private: false },
  { code: "LGB", name: "Long Beach",             full: "Long Beach Airport",                 slug: "lgb",     private: false },
  { code: "BUR", name: "Hollywood Burbank",      full: "Hollywood Burbank Airport",          slug: "bur",     private: false },
  { code: "ONT", name: "Ontario Intl",           full: "Ontario International Airport",      slug: "ont",     private: false },
  { code: "PSP", name: "Palm Springs Intl",      full: "Palm Springs International Airport", slug: "psp",     private: false },
  { code: "VNY", name: "Van Nuys",               full: "Van Nuys Airport",                   slug: "vny",     private: false },
  { code: "FBO", name: "Private Aviation",       full: "Private FBO / Executive Terminals",  slug: "private", private: true  },
];

export const AIRPORT_MAP = AIRPORTS.reduce((a, x) => (a[x.code] = x, a), {});

export const AIRPORT_SERVICES = [
  "Private Airport Pickups",
  "Flight Tracking",
  "Meet & Greet Service",
  "Curbside Assistance",
];

export const CORPORATE = [
  "Corporate Accounts",
  "Executive Travel",
  "Group Transportation",
  "Dedicated Account Manager",
];

export const TESTIMONIALS = [
  { quote: "Voor Black is simply the best. Professional, punctual and the vehicles are immaculate. My go-to for all business travel.", name: "James R.", role: "CEO" },
  { quote: "I use Voor Black for airport transfers and long distance trips. Every experience is perfect from start to finish.", name: "Sarah M.", role: "Entrepreneur" },
  { quote: "Reliable, luxurious and worth every penny. They truly respect your time.", name: "Michael T.", role: "Business Executive" },
];

export const TIME_SLOTS = (() => {
  const out = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 30]) {
      const hr = h % 12 === 0 ? 12 : h % 12;
      const ap = h < 12 ? "AM" : "PM";
      out.push(`${hr}:${m === 0 ? "00" : "30"} ${ap}`);
    }
  }
  return out;
})();
